import { render, staticRenderFns } from "./newCertificate.vue?vue&type=template&id=7fffefa8&scoped=true&"
import script from "./newCertificate.vue?vue&type=script&lang=js&"
export * from "./newCertificate.vue?vue&type=script&lang=js&"
import style0 from "./newCertificate.vue?vue&type=style&index=0&id=7fffefa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fffefa8",
  null
  
)

export default component.exports